export default "__VITE_ASSET__136443e9__"